import { makeStyles, styled } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  tabPanel: {
    padding: theme.spacing(3)
  }
}));

export const TabLoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
